import P30P32Report from './P30P32Report';

const P32Report = () => <P30P32Report reportType="P32" />;

export default P32Report;
